import Route from "./route";
import ProtectedRoute from "./protected-route";

export { ProtectedRoute };
export default Route;
